import MultiEmailInput from "@components/common/inputs/MultiEmailInput";

import { alert } from "../../common/Alert";

const AddUsers = ({
  newUserEmails,
  setNewUserEmails,
  team = { uuid: "", users: [] },
}) => {
  const teamUsersArray = team?.users?.map((user) => user.email) || [];
  const invitedMembers =
    team?.teamInvites
      ?.filter((invite) => invite.status === "pending")
      ?.map((invite) => invite.inviteeEmail) || [];

  const customValidation = (email) => {
    // Check if already invited
    if (invitedMembers?.includes(email)) {
      alert("warning", `${email} is already invited to this team.`);
      return false;
    }

    // Check domain restriction — accept any of the org's configured allowed
    // email domains (1-3 slots). Falls back to the single emailDomain field
    // for orgs that haven't been migrated to the multi-domain GraphQL fields
    // yet (defense in depth — server is the source of truth either way).
    const allowed =
      team?.allowedEmailDomains?.length > 0
        ? team.allowedEmailDomains
        : team?.emailDomain
          ? [team.emailDomain]
          : [];
    if (allowed.length > 0) {
      const domain = email?.split("@")[1]?.toLowerCase();
      const matches = allowed.some(
        (d) => d?.toLowerCase() === domain,
      );
      if (!matches) {
        const formatted = allowed.map((d) => `@${d}`).join(", ");
        alert(
          "error",
          `Your organization only allows users with one of these email domains: ${formatted}.`,
        );
        return false;
      }
    }

    return true;
  };

  return (
    <div className="mt-2">
      <MultiEmailInput
        emails={newUserEmails}
        setEmails={setNewUserEmails}
        placeholder="Add user"
        infoText="Type in the email of each new team member."
        customValidation={customValidation}
        existingEmails={teamUsersArray}
        dataTestId="add-user-textarea"
      />
    </div>
  );
};

export default AddUsers;
